export const NJ_WS_URL = process.env.NEXT_PUBLIC_NJ_WS_URL || "ws://localhost:8001";
export const GO_REST_URL = process.env.NEXT_PUBLIC_GO_API_URL || "http://localhost:8002"